import { commentsReducer, CommentsState, initialCommentsState } from './comments/commentsReducer'
import { combineReducers } from "redux";
import { documentGroupReducer, DocumentGroupState, initialDocumentGroupState } from './group/documentGroupReducer';
import { moveMenuContextGroupReducer, initialMoveMenuContextGroupState } from './group/moveMenuContextGroupReducer';
import { initialPredecessorsState, predecessorsReducer, PredecessorsState } from './predecessors/predecessorsReducer';

export interface DocumentsAdditionalData {
    predecessors: PredecessorsState
    comments: CommentsState
    documentGroup: DocumentGroupState
    moveMenuContextGroup: DocumentGroupState
}

export const documentsAdditionalDataReducer = combineReducers({
    predecessors: predecessorsReducer,
    comments: commentsReducer,
    documentGroup: documentGroupReducer,
    moveMenuContextGroup: moveMenuContextGroupReducer
})

export const initialDocumentsAdditionalDataState: DocumentsAdditionalData = {
    predecessors: initialPredecessorsState,
    comments: initialCommentsState,
    documentGroup: initialDocumentGroupState,
    moveMenuContextGroup: initialMoveMenuContextGroupState,
}